import React, {useState} from 'react';
import {createStyles, makeStyles} from "@mui/styles";
import {Theme} from "@mui/material/styles";
import Wizard from "../../../../components/wizard/Wizard";
import UploadFilePanel from "../../../../components/UploadFilePanel";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {WizardStep} from "../../../../components/wizard/WizardStep";
import {t} from "../../../../store/localization/TranslMessasge";
import {BlobUtils} from "../../../../common/BlobUtils";
import {useNavigate} from "react-router-dom";
import {ModelsComparisonTranslationKey} from "./ModelsComparisonTranslationKey";
import modelsComparisonService from "./ModelsComparisonService";
import Page from "../../../../components/page/Page";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import PageContent from "../../../../components/page/PageContent";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        uploadContentFileName: {
            fontSize: "1.4em",
        },
    })
);

export default function ModelsComparisonPage() {

    const [firstModelFile, setFirstModelFile] = useState<File>();
    const [secondModelFile, setSecondModelFile] = useState<File>();

    const classes = useStyles();
    const navigate = useNavigate();

    function getSteps(): WizardStep[] {
        return [
            new WizardStep(t(ModelsComparisonTranslationKey.SELECT_FIRST_MODEL_FILE_STEP_LABEL), <CloudUploadIcon/>, t(ModelsComparisonTranslationKey.SELECT_FIRST_MODEL_FILE_STEP_DESCRIPTION), false,
                () => renderSelectModelFileStep(firstModelFile, setFirstModelFile), () => firstModelFile != null),
            new WizardStep(t(ModelsComparisonTranslationKey.SELECT_SECOND_MODEL_FILE_STEP_LABEL), <CloudUploadIcon/>, t(ModelsComparisonTranslationKey.SELECT_SECOND_MODEL_FILE_STEP_DESCRIPTION), false,
                () => renderSelectModelFileStep(secondModelFile, setSecondModelFile), () => secondModelFile != null)
        ];
    }

    function renderSelectModelFileStep(modelFile: File | undefined, setModelFile: React.Dispatch<React.SetStateAction<File | undefined>>): JSX.Element {
        const uploadPanelContentGetter = modelFile != null ? () => createFileInfoPanel(modelFile) : undefined;

        return <UploadFilePanel uploadAttachment={file => setModelFile(file)}
                                uploadPanelContent={uploadPanelContentGetter} />
    }

    function createFileInfoPanel(selectedFile: File): JSX.Element {
        return <div className={classes.uploadContentFileName}>{selectedFile?.name}</div>;
    }

    function doExport(): Promise<BlobPart> {
        return modelsComparisonService.compareModels(firstModelFile as File, secondModelFile as File);
    }

    function resetImport() {
        navigate(0);
    }


    return (
        <Page>
            <PageHeader>
                <PageTitle title={t(ModelsComparisonTranslationKey.PAGE_TITLE)} />
            </PageHeader>
            <PageContent>
                <Wizard steps={getSteps()}
                        lastStepLabel={t(ModelsComparisonTranslationKey.LAST_STEP_LABEL)}
                        lastStepButtonLabel={t(ModelsComparisonTranslationKey.LAST_STEP_BUTTON_LABEL)}
                        lastStepAction={() => doExport()}
                        lastStepActionSuccessProcessor={(result) => {
                            const blob = new Blob([result as BlobPart]);
                            BlobUtils.saveBlob(blob, "DifferencesReport.xlsx");
                        }}
                        lastStepActionInProgressText={t(ModelsComparisonTranslationKey.LAST_STEP_ACTION_IN_PROGRESS_TEXT)}
                        lastStepActionSuccessfulText={t(ModelsComparisonTranslationKey.LAST_STEP_ACTION_SUCCESSFUL_TEXT)}
                        lastStepActionFailedText={t(ModelsComparisonTranslationKey.LAST_STEP_ACTION_FAILED_TEXT)}
                        cancelWizard={() => resetImport()}
                        wizardGridMinHeight={"25em"}
                />
            </PageContent>
        </Page>
    );
}
